import { useState } from 'react';
import { ISolicitationViewModel } from 'viewModels';
import { useTheme } from 'styled-components';
import { ReactComponent as IconView } from '../../../assets/icons/icon-view.svg';
import { ModalDetailsService } from '../../Modals/ModalDetailsSolicitation';
import { Container, Description, Title } from './styles';
import { Button } from '../..';

type Props = {
  zIndex: number;
  left: number;
  solicitation?: ISolicitationViewModel;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export function CardOpenSolicitation({
  zIndex,
  left,
  solicitation,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const [displayModalDetailsEvents, setDisplayModalDetailsEvents] = useState(false);
  const theme = useTheme();
  return (
    <Container onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter} zIndex={zIndex} left={left}>
      <>
        <div id="divContainerEvents">
          <Title>{solicitation?.correspondence.name}</Title>
          <Button
            LeftComponent={IconView}
            text=""
            onClick={() => {
              setDisplayModalDetailsEvents(true);
            }}
            styleLeftComponent={{ fill: theme.colors.primary }}
            backgroundHoverColor="transparent"
            dimensions={{
              width: '2rem',
              height: '1rem',
            }}
          />
        </div>
        <Description>{solicitation?.specialty?.name ?? '-'}</Description>
      </>
      {solicitation && displayModalDetailsEvents && (
        <ModalDetailsService
          solicitation={solicitation}
          isOpen={displayModalDetailsEvents}
          onRequestClose={() => {
            setDisplayModalDetailsEvents(false);
            onMouseLeave();
          }}
        />
      )}
    </Container>
  );
}
